import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLazyQuery } from '@apollo/client';

import { DownloadModal } from '@playbookux/playbook-web-core';
import { GET_HIGHLIGHT_REEL_BY_ID } from '../graphql';

const ERROR_MESSAGE = "We're not able to process this highlight reel. Please contact support.";
const HANG_TIGHT_MESSAGE = "Hang tight! We're processing your highlight reel";
const DOWNLOAD_READY_MESSAGE = 'Your highlight reel is ready';

const DownloadHighlightReel = (props) => {
  const {
    onClose,
    open,
    highlightReelId,
  } = props;

  const [loading, setLoading] = useState(false);

  const [startPolling, { data = {}, stopPolling }] = useLazyQuery(GET_HIGHLIGHT_REEL_BY_ID, {
    variables: { id: highlightReelId },
    pollInterval: 3000,
  });

  useEffect(() => {
    if (open) {
      setLoading(true);
      startPolling();
    }
  }, [open, startPolling]);

  const { highlightReel } = data;
  const showDownloadButton = highlightReel && highlightReel.status === 'processed';
  const processingError = highlightReel && highlightReel.status === 'error';

  useEffect(() => {
    if (showDownloadButton || processingError) {
      setLoading(false);
      stopPolling();
    }
  }, [showDownloadButton, processingError, stopPolling, setLoading]);

  let label = '';
  if (processingError) {
    label = ERROR_MESSAGE;
  } else {
    label = showDownloadButton ? DOWNLOAD_READY_MESSAGE : HANG_TIGHT_MESSAGE;
  }

  return (
    <DownloadModal
      label={label}
      loading={loading}
      onClose={onClose}
      open={open}
      showButton={showDownloadButton}
      submit={() => window.open(highlightReel.videoUrl)}
    />
  );
};

DownloadHighlightReel.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  highlightReelId: PropTypes.string.isRequired,
};

export default DownloadHighlightReel;
